import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) { }
 
  public getHomePageData() {
		return this.http.get(environment.apiUrl+'/api/home');
  }
  
  public getAboutusPageData() {
		return this.http.get(environment.apiUrl+'/api/aboutus');
  }
  
  public getFacilitiesPageData(){
    return this.http.get(environment.apiUrl+'/api/facilities');
  }

  public getProductsPageData(){
    return this.http.get(environment.apiUrl+'/api/ourproducts');
  }

  public getcontactPageData(){
    return this.http.get(environment.apiUrl+'/api/contact');
  }

  public postContactus(data){
    return this.http.post(environment.apiUrl+'/api/getintouch', data);
  }

  public getFooter(){
    return this.http.get(environment.apiUrl+'/api/footer');
  }

}
